import React from "react";
import { Tooltip } from "antd";
import { iconsDetailsProyectMenu } from "../../assets/icons/detailsProjectMenu";

export const ButtonFab = ({ menuItems = [], valueOpen, actionActive }) => {
	return (
		<div className="fixed z-50 bottom-5 right-5 lg:right-14 flex flex-col items-center justify-center gap-4">
			<div className={`${valueOpen ? "open-menu" : "close-menu"} flex  flex-col items-center justify-center gap-4 `}>
				{menuItems.map(({ text, action, img }, index) => (
					<Tooltip key={`${index}-menudetails`} placement="left" title={text}>
						<div
							onClick={() => {
								action();
							}}
							className="w-[45px] h-[45px] bg-[#FCF9F9] rounded-full p-3 hover:cursor-pointer"
						>
							<img className="w-full h-full object-contain" src={img} alt="icon" />
						</div>
					</Tooltip>
				))}
			</div>
			<div
				onClick={() => {
					actionActive(!valueOpen);
				}}
				className="w-[45px] h-[45px] bg-[#FCF9F9] rounded-full p-3 hover:cursor-pointer"
			>
				<img
					className="w-full h-full object-contain"
					src={`${valueOpen ? iconsDetailsProyectMenu.closemenu : iconsDetailsProyectMenu.openmenu}`}
					alt="icon"
				/>
			</div>
		</div>
	);
};
